module.exports = __webpack_public_path__ + "img/big_1_6.f71f3e11.png";